import * as React from "react";
import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Typography from "@mui/material/Typography";
import { Divider } from "@mui/material";
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import './eventsCard.css'

export default function EventsCard({
    event_name, content, coinsUsed, hashtags, likes, views, image_url, url, country, icons, startDate, endDate,
}) {
    const cardRef = React.useRef();

    function isMobile() {
        const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const minSize = 450;
        return screenWidth <= minSize;
    }
    const handleCardClick = () => {
        console.log("handleCardClick");
        window.open(url);
    };

    const formatDateTime = (date) => {
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        const formattedDate = new Date(date).toLocaleDateString('en-GB', options);
        const formattedTime = new Date(date).toLocaleTimeString('en-GB', { hour: 'numeric', minute: 'numeric', hour12: true });

        return `${formattedDate} @ ${formattedTime}`;
    };

    const formattedStartDate = formatDateTime(startDate);
    const formattedEndDate = formatDateTime(endDate);

    const formattedDateRange = startDate === endDate ? formattedStartDate : `${formattedStartDate} - ${formattedEndDate}`;


    return (
        <Card onClick={handleCardClick} className="event-card"
            sx={{
                border: "1px solid rgba(79, 79, 79, 0.70)",
                borderRadius: "10px",
                backgroundOrigin: "center",
                backgroundSize: "cover",
                minWidth: "100%",
                height: "347px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
            }}
            elevation={5}
        >
            <CardContent className="events-card-content" sx={{ height: "182px" }}>
                <div className="image-container">
                    <img className="event-card-img" src={image_url} alt="event" />
                    {/* <div className="text-overlay">
                        {formattedDateRange}</div> */}
                </div>
            </CardContent>

            <Box sx={{ height: "60px", margin: "14px" }}>

                <Typography className="event-content">
                    {content}
                </Typography>
            </Box>


            <Box

                sx={{
                    display: "flex",
                    padding: "0px 14px",
                    justifyContent: "space-between",
                    gap: "10px",
                    alignItems: "center",
                    height: "20px",
                    flexDirection: "row",
                }}
            >
                <Box
                    sx={{ display: "flex", gap: isMobile() ? "3px" : "5px", width: "max-content", marginLeft: isMobile() ? "-5px" : "0px" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: isMobile() ? "3px" : "5px" }}>
                        <img
                            style={{ width: "15px", height: "15px", }}
                            src={icons?.[coinsUsed.toUpperCase()]}
                            alt={coinsUsed.toLowerCase()}
                        />
                        {/* <Icon name={coinsUsed.toLowerCase()} url={icons?.[coinsUsed.toUpperCase()]} /> */}
                        <Typography sx={{ fontSize: isMobile() ? "14px" : "16px", color: "#928F95" }}>{coinsUsed}</Typography>
                    </Box>
                </Box>

                <Typography sx={{ fontSize: isMobile() ? "14px" : "16px", color: "#928F95" }}>{hashtags}</Typography>
            </Box>




            <Box

                sx={{
                    display: "flex",
                    padding: "14px 14px",
                    gap: "10px",
                    alignItems: "flex-start",
                    flexDirection: "row",
                    height: "auto",
                }}
            >
                <AccessTimeFilledIcon
                    style={{
                        color: "#BBB9BC",
                        fontSize: "16px",
                        paddingTop:"5px"
                    }}
                />
                <Typography sx={{ fontSize: isMobile() ? "14px" : "16px", color: "#928F95" }}>
                    {formattedDateRange}

                </Typography>

            </Box>

        </Card>
    );
}
